import { RoleName } from "consts/auth";
import type { TabsProps, Tab } from "ui/atoms/Tabs";

export interface RoleBasedTabsProps extends TabsProps {
    readonly model: Array<Tab & {
        readonly roles?: Array<RoleName>;
    }>;
}

export type StatefulTabsProps = TabsProps & {
    readonly searchParamName?: string;
};

export const enum StatefulTabs {
    InitialValue = '1',
    SearchParamName = 'activeTab'
};
